module.exports = __webpack_public_path__ + "static/media/atom.8098a46e.ico";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/atom.ico
// module id = 68
// module chunks = 0